var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubDepartment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_93725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_93725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21C3.45 21 2.97933 20.8043 2.588 20.413C2.196 20.021 2 19.55 2 19V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H10C10.55 3 11.021 3.19567 11.413 3.587C11.8043 3.979 12 4.45 12 5V7H20C20.55 7 21.021 7.19567 21.413 7.587C21.8043 7.979 22 8.45 22 9V15H20V9H12V11H14V13H12V15H14V17H12V19H16V21H4ZM4 19H6V17H4V19ZM4 15H6V13H4V15ZM4 11H6V9H4V11ZM4 7H6V5H4V7ZM8 19H10V17H8V19ZM8 15H10V13H8V15ZM8 11H10V9H8V11ZM8 7H10V5H8V7ZM21 23C20.7167 23 20.4793 22.904 20.288 22.712C20.096 22.5207 20 22.2833 20 22V21H19C18.7167 21 18.4793 20.904 18.288 20.712C18.096 20.5207 18 20.2833 18 20C18 19.7167 18.096 19.4793 18.288 19.288C18.4793 19.096 18.7167 19 19 19H20V18C20 17.7167 20.096 17.4793 20.288 17.288C20.4793 17.096 20.7167 17 21 17C21.2833 17 21.5207 17.096 21.712 17.288C21.904 17.4793 22 17.7167 22 18V19H23C23.2833 19 23.5207 19.096 23.712 19.288C23.904 19.4793 24 19.7167 24 20C24 20.2833 23.904 20.5207 23.712 20.712C23.5207 20.904 23.2833 21 23 21H22V22C22 22.2833 21.904 22.5207 21.712 22.712C21.5207 22.904 21.2833 23 21 23ZM16 13V11H18V13H16ZM16 17V15H18V17H16Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubDepartment);
export default __webpack_public_path__ + "static/media/sub_department.5ca025614e067e3fc7c9d468aa11b395.svg";
export { ForwardRef as ReactComponent };